/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CalculateHashResponse,
  CaptchaValidationDto,
  CredentialRevocationNotificationDto,
  DnsSignatureValidationDto,
  FindOrgLarsResponseDto,
  OrgDetailResponseDto,
  OrgDto,
  QviOrgIdResponseDto,
  RoleAcceptanceResponseDto,
  TimeSlotResponse,
  UserInOrgAndGrantResponseDto,
  UserVerificationProcessDto,
} from '../models/index';
import {
    CalculateHashResponseFromJSON,
    CalculateHashResponseToJSON,
    CaptchaValidationDtoFromJSON,
    CaptchaValidationDtoToJSON,
    CredentialRevocationNotificationDtoFromJSON,
    CredentialRevocationNotificationDtoToJSON,
    DnsSignatureValidationDtoFromJSON,
    DnsSignatureValidationDtoToJSON,
    FindOrgLarsResponseDtoFromJSON,
    FindOrgLarsResponseDtoToJSON,
    OrgDetailResponseDtoFromJSON,
    OrgDetailResponseDtoToJSON,
    OrgDtoFromJSON,
    OrgDtoToJSON,
    QviOrgIdResponseDtoFromJSON,
    QviOrgIdResponseDtoToJSON,
    RoleAcceptanceResponseDtoFromJSON,
    RoleAcceptanceResponseDtoToJSON,
    TimeSlotResponseFromJSON,
    TimeSlotResponseToJSON,
    UserInOrgAndGrantResponseDtoFromJSON,
    UserInOrgAndGrantResponseDtoToJSON,
    UserVerificationProcessDtoFromJSON,
    UserVerificationProcessDtoToJSON,
} from '../models/index';

export interface AcceptanceForGrantRequest {
    encryptedParams: string;
}

export interface AvailableTimeSlotsRequest {
    after: string;
    before: string;
    minutes?: number;
    requiredNumberOfQars?: number;
    workflow?: string;
}

export interface CalculateHashRequest {
    url: string;
}

export interface CaptchaValidationRequest {
    captchaValidationDto: CaptchaValidationDto;
}

export interface CredentialRevocationNotificationRequest {
    credentialRevocationNotificationDto: CredentialRevocationNotificationDto;
}

export interface DnsSignatureValidationRequest {
    dnsSignatureValidationDto: DnsSignatureValidationDto;
}

export interface FindAllUsersInOrgAndGrantRequest {
    org: string;
    role: string;
}

export interface FindOrgLarsRequest {
    workflow?: string;
}

export interface FindUserForOrgAndGrantRequest {
    user: string;
    org: string;
    role: string;
}

export interface FindUserVerificationDetailsRequest {
    user: string;
    workflow?: string;
}

export interface GetOrgByWorkflowInstanceIdRequest {
    workflow?: string;
}

export interface GetQviOrgIdByWorkflowInstanceIdRequest {
    workflow?: string;
}

export interface IsLeiStatusValidRequest {
    workflow?: string;
}

export interface OrgDetailRequest {
    workflow?: string;
}

/**
 * 
 */
export class UtilControllerApi extends runtime.BaseAPI {

    /**
     * User accepts proposed grant
     */
    async acceptanceForGrantRaw(requestParameters: AcceptanceForGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleAcceptanceResponseDto>> {
        if (requestParameters['encryptedParams'] == null) {
            throw new runtime.RequiredError(
                'encryptedParams',
                'Required parameter "encryptedParams" was null or undefined when calling acceptanceForGrant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/util/acceptance/{encrypted-params}`.replace(`{${"encrypted-params"}}`, encodeURIComponent(String(requestParameters['encryptedParams']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleAcceptanceResponseDtoFromJSON(jsonValue));
    }

    /**
     * User accepts proposed grant
     */
    async acceptanceForGrant(requestParameters: AcceptanceForGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleAcceptanceResponseDto> {
        const response = await this.acceptanceForGrantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Finds and returns QARs available appointment slots for issuance ceremony
     * Available timeslots
     */
    async availableTimeSlotsRaw(requestParameters: AvailableTimeSlotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TimeSlotResponse>>> {
        if (requestParameters['after'] == null) {
            throw new runtime.RequiredError(
                'after',
                'Required parameter "after" was null or undefined when calling availableTimeSlots().'
            );
        }

        if (requestParameters['before'] == null) {
            throw new runtime.RequiredError(
                'before',
                'Required parameter "before" was null or undefined when calling availableTimeSlots().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }

        if (requestParameters['before'] != null) {
            queryParameters['before'] = requestParameters['before'];
        }

        if (requestParameters['minutes'] != null) {
            queryParameters['minutes'] = requestParameters['minutes'];
        }

        if (requestParameters['requiredNumberOfQars'] != null) {
            queryParameters['requiredNumberOfQars'] = requestParameters['requiredNumberOfQars'];
        }

        if (requestParameters['workflow'] != null) {
            queryParameters['workflow'] = requestParameters['workflow'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/util/available-appt-slots-for-qars`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TimeSlotResponseFromJSON));
    }

    /**
     * Finds and returns QARs available appointment slots for issuance ceremony
     * Available timeslots
     */
    async availableTimeSlots(requestParameters: AvailableTimeSlotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TimeSlotResponse> | null | undefined > {
        const response = await this.availableTimeSlotsRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Calculates logo hash in RSA256
     * Calculates logo hash
     */
    async calculateHashRaw(requestParameters: CalculateHashRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CalculateHashResponse>> {
        if (requestParameters['url'] == null) {
            throw new runtime.RequiredError(
                'url',
                'Required parameter "url" was null or undefined when calling calculateHash().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['url'] != null) {
            queryParameters['url'] = requestParameters['url'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/util/hash-image`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CalculateHashResponseFromJSON(jsonValue));
    }

    /**
     * Calculates logo hash in RSA256
     * Calculates logo hash
     */
    async calculateHash(requestParameters: CalculateHashRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CalculateHashResponse | null | undefined > {
        const response = await this.calculateHashRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * For dev needs. Returns 200 if captcha check passed, 422 Unprocessable Entity if no.
     * Captcha token check
     */
    async captchaValidationRaw(requestParameters: CaptchaValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['captchaValidationDto'] == null) {
            throw new runtime.RequiredError(
                'captchaValidationDto',
                'Required parameter "captchaValidationDto" was null or undefined when calling captchaValidation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/util/captcha-validation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CaptchaValidationDtoToJSON(requestParameters['captchaValidationDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * For dev needs. Returns 200 if captcha check passed, 422 Unprocessable Entity if no.
     * Captcha token check
     */
    async captchaValidation(requestParameters: CaptchaValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.captchaValidationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send email notification to all QARs about credential revocation. Returns credential from request
     * Credential revocation notification
     */
    async credentialRevocationNotificationRaw(requestParameters: CredentialRevocationNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['credentialRevocationNotificationDto'] == null) {
            throw new runtime.RequiredError(
                'credentialRevocationNotificationDto',
                'Required parameter "credentialRevocationNotificationDto" was null or undefined when calling credentialRevocationNotification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/util/credential-revocation-notification`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CredentialRevocationNotificationDtoToJSON(requestParameters['credentialRevocationNotificationDto']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Send email notification to all QARs about credential revocation. Returns credential from request
     * Credential revocation notification
     */
    async credentialRevocationNotification(requestParameters: CredentialRevocationNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.credentialRevocationNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * For dev needs. Returns 200 if DNS signature is valid, 422 Unprocessable Entity if no.
     * DNS signature validation
     */
    async dnsSignatureValidationRaw(requestParameters: DnsSignatureValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['dnsSignatureValidationDto'] == null) {
            throw new runtime.RequiredError(
                'dnsSignatureValidationDto',
                'Required parameter "dnsSignatureValidationDto" was null or undefined when calling dnsSignatureValidation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/util/dns-signature-validation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DnsSignatureValidationDtoToJSON(requestParameters['dnsSignatureValidationDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * For dev needs. Returns 200 if DNS signature is valid, 422 Unprocessable Entity if no.
     * DNS signature validation
     */
    async dnsSignatureValidation(requestParameters: DnsSignatureValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.dnsSignatureValidationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Finds users with specific grant in an org
     * Get users by grant
     */
    async findAllUsersInOrgAndGrantRaw(requestParameters: FindAllUsersInOrgAndGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserInOrgAndGrantResponseDto>>> {
        if (requestParameters['org'] == null) {
            throw new runtime.RequiredError(
                'org',
                'Required parameter "org" was null or undefined when calling findAllUsersInOrgAndGrant().'
            );
        }

        if (requestParameters['role'] == null) {
            throw new runtime.RequiredError(
                'role',
                'Required parameter "role" was null or undefined when calling findAllUsersInOrgAndGrant().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['org'] != null) {
            queryParameters['org'] = requestParameters['org'];
        }

        if (requestParameters['role'] != null) {
            queryParameters['role'] = requestParameters['role'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/util/grant/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserInOrgAndGrantResponseDtoFromJSON));
    }

    /**
     * Finds users with specific grant in an org
     * Get users by grant
     */
    async findAllUsersInOrgAndGrant(requestParameters: FindAllUsersInOrgAndGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserInOrgAndGrantResponseDto> | null | undefined > {
        const response = await this.findAllUsersInOrgAndGrantRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Get org LARs by workflow instance id
     * Get org LARs
     */
    async findOrgLarsRaw(requestParameters: FindOrgLarsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOrgLarsResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['workflow'] != null) {
            queryParameters['workflow'] = requestParameters['workflow'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/util/org-lars`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOrgLarsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get org LARs by workflow instance id
     * Get org LARs
     */
    async findOrgLars(requestParameters: FindOrgLarsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOrgLarsResponseDto> {
        const response = await this.findOrgLarsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get specific grant details of user in an org
     */
    async findUserForOrgAndGrantRaw(requestParameters: FindUserForOrgAndGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserInOrgAndGrantResponseDto>> {
        if (requestParameters['user'] == null) {
            throw new runtime.RequiredError(
                'user',
                'Required parameter "user" was null or undefined when calling findUserForOrgAndGrant().'
            );
        }

        if (requestParameters['org'] == null) {
            throw new runtime.RequiredError(
                'org',
                'Required parameter "org" was null or undefined when calling findUserForOrgAndGrant().'
            );
        }

        if (requestParameters['role'] == null) {
            throw new runtime.RequiredError(
                'role',
                'Required parameter "role" was null or undefined when calling findUserForOrgAndGrant().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['user'] != null) {
            queryParameters['user'] = requestParameters['user'];
        }

        if (requestParameters['org'] != null) {
            queryParameters['org'] = requestParameters['org'];
        }

        if (requestParameters['role'] != null) {
            queryParameters['role'] = requestParameters['role'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/util/grant`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserInOrgAndGrantResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get specific grant details of user in an org
     */
    async findUserForOrgAndGrant(requestParameters: FindUserForOrgAndGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserInOrgAndGrantResponseDto | null | undefined > {
        const response = await this.findUserForOrgAndGrantRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Returns a list, as it is possible in case the user validates their identity more than once
     * Get ID verification detail of user
     */
    async findUserVerificationDetailsRaw(requestParameters: FindUserVerificationDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserVerificationProcessDto>> {
        if (requestParameters['user'] == null) {
            throw new runtime.RequiredError(
                'user',
                'Required parameter "user" was null or undefined when calling findUserVerificationDetails().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['user'] != null) {
            queryParameters['user'] = requestParameters['user'];
        }

        if (requestParameters['workflow'] != null) {
            queryParameters['workflow'] = requestParameters['workflow'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/util/user-verification-details`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserVerificationProcessDtoFromJSON(jsonValue));
    }

    /**
     * Returns a list, as it is possible in case the user validates their identity more than once
     * Get ID verification detail of user
     */
    async findUserVerificationDetails(requestParameters: FindUserVerificationDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserVerificationProcessDto | null | undefined > {
        const response = await this.findUserVerificationDetailsRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Get Org parameters for workflow instance id
     * Get Org parameters
     */
    async getOrgByWorkflowInstanceIdRaw(requestParameters: GetOrgByWorkflowInstanceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgDto>> {
        const queryParameters: any = {};

        if (requestParameters['workflow'] != null) {
            queryParameters['workflow'] = requestParameters['workflow'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/util/org`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgDtoFromJSON(jsonValue));
    }

    /**
     * Get Org parameters for workflow instance id
     * Get Org parameters
     */
    async getOrgByWorkflowInstanceId(requestParameters: GetOrgByWorkflowInstanceIdRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgDto | null | undefined > {
        const response = await this.getOrgByWorkflowInstanceIdRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Get QVI org Id for specified workflow instance
     */
    async getQviOrgIdByWorkflowInstanceIdRaw(requestParameters: GetQviOrgIdByWorkflowInstanceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QviOrgIdResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['workflow'] != null) {
            queryParameters['workflow'] = requestParameters['workflow'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/util/qvi-org-id`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QviOrgIdResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get QVI org Id for specified workflow instance
     */
    async getQviOrgIdByWorkflowInstanceId(requestParameters: GetQviOrgIdByWorkflowInstanceIdRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QviOrgIdResponseDto | null | undefined > {
        const response = await this.getQviOrgIdByWorkflowInstanceIdRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * True - status is ok, false - not ok (for example, expired), empty - result is unknown
     * Returns LEI status
     */
    async isLeiStatusValidRaw(requestParameters: IsLeiStatusValidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters['workflow'] != null) {
            queryParameters['workflow'] = requestParameters['workflow'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/util/lei-status-ok`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * True - status is ok, false - not ok (for example, expired), empty - result is unknown
     * Returns LEI status
     */
    async isLeiStatusValid(requestParameters: IsLeiStatusValidRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean | null | undefined > {
        const response = await this.isLeiStatusValidRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Get org, workflow and recipients parameters for the specified workflow
     * Get Org details
     */
    async orgDetailRaw(requestParameters: OrgDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgDetailResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['workflow'] != null) {
            queryParameters['workflow'] = requestParameters['workflow'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/util/org-detail`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgDetailResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get org, workflow and recipients parameters for the specified workflow
     * Get Org details
     */
    async orgDetail(requestParameters: OrgDetailRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgDetailResponseDto> {
        const response = await this.orgDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
